// Footer Nav
function resizeHandler() {
    console.log("window resized");

    if ($(window).width() < 767) {
        console.log("window small than 600");

        $('.footer-nav ul').hide();
        $('.footer-nav ul').slideUp(200);
    } else {
        $('.footer-nav ul').show();
        $('.footer-nav-header').removeClass("expanded");
    }
}

resizeHandler();

$(window).resize(resizeHandler);

$('body').on('click', '.footer-nav-header', function () {
    if ($(window).width() < 767) {
        $(this).next().slideToggle(200);
        $(this).toggleClass("expanded");
    }
});

// Move Accessibility icon on desktop
function applyShadowHostStyles() {
    if (window.innerWidth < 1024) return;

    const processed = new WeakSet(); // avoid reprocessing the same shadow roots

    const interval = setInterval(() => {
        const widgets = document.querySelectorAll('access-widget-ui');

        widgets.forEach(widget => {
            if (widget.shadowRoot && !processed.has(widget.shadowRoot)) {
                const style = document.createElement('style');
                style.textContent = `
                    .position-x-left {
                        left: 12px !important;
                    }
                    .position-y-bottom {
                        bottom: 120px !important;
                    }`;
                widget.shadowRoot.appendChild(style);
                processed.add(widget.shadowRoot);
            }
        });

        // Stop after 5 seconds
        if (document.querySelectorAll('access-widget-ui').length === processed.size) {
            clearInterval(interval);
        }
    }, 200);

    setTimeout(() => clearInterval(interval), 5000);
}

window.addEventListener('DOMContentLoaded', applyShadowHostStyles);
window.addEventListener('resize', () => {
    if (window.innerWidth >= 1024) {
        applyShadowHostStyles();
    }
});
// Initialize Okendo widgets in smartcart drawer

(function() {

      document.addEventListener('rebuy:smartcart.show', (event) => {
        window.okeLoyaltyApi?.initialiseWidgets();
      });
            
  })();
